export const chatSupportLink =
  "https://chat.whatsapp.com/C87b11KJdZR9cNtuhkrReZ?mode=gi_t";

export const supportEmail = "verity@getnoan.com";

export const demoCalendlyLink =
  "https://calendly.com/neal-getnoan/founder-demo";

export const apiDocsLink = "https://api.getnoan.com/docs/";
export const apiSpecLink = "https://api.getnoan.com/openapi.json";
export const apiBaseLink = "https://api.getnoan.com/v1";
export const mcpBaseLink = "https://mcp.getnoan.com/mcp";
export const skillLink = "https://getnoan.com/skill.md";
export const changelogLink = "https://www.getnoan.com/changelog";
export const agentPlannerLink = "https://www.getnoan.com/agent-planner";
